import React from 'react'
import Select from 'react-select'
import styles from './Select.module.css'
import './Select.css'
import { useTranslation } from 'react-i18next'

export default function Selector({
	options,
	value,
	placeholder,
	onChange,
	isSearchable,
	isDisabled,
	isClearable,
	title,
	name,
	withBorder
}) {
	const colourStyles = {
		control: (styles, { isDisabled }) => {
			return {
				...styles,
				cursor: isDisabled ? 'not-allowed' : 'default',
				border: withBorder ? '1px solid grey' : 'none !important',
				backgroundColor: isDisabled ? '#F7F7FC' : '#fff'
			}
		},
		option: (provided, state) => ({
			...provided,
			fontWeight: state.isSelected ? 'bold' : 'normal',
			color: state.isSelected ? '#fff' : state.data.color,
			zIndex: '15225',
			backgroundColor:
				state.isFocused && state.isSelected ? '#91A3CD' : state.isFocused ? '#EDF2F7' : state.isSelected ? '#91A3CD' : '#fff'
		})
	}
	const { t } = useTranslation()

	return (
		<div className={styles.SelectorWrapper} style={{ marginRight: '24px' }}>
			{title ? <p className={styles.title}>{title}</p> : null}
			<Select
				className={styles.Select}
				classNamePrefix='my_select'
				value={value}
				name={name}
				placeholder={placeholder}
				onChange={onChange}
				options={options}
				isSearchable={isSearchable ? true : false}
				isDisabled={isDisabled}
				styles={colourStyles}
				isClearable={isClearable}
			/>
		</div>
	)
}
